import React from 'react';
import { useDispatch } from 'react-redux';
import Txt from '../../../inputs/textInput.js';
import Lbl from '../../../inputs/label.js';
import objectAssign from 'object-assign';
import { Dropdown } from 'semantic-ui-react';
import { updateAfterCallsForm } from '../../../../actions/waitingArea.js';
import { ValidMe } from '../../../../businessLogic/validation.js';

const PurgeCallsOptions = [
  { value: 'true', text: APP.LANGUAGE.Yes },
  { value: 'false', text: APP.LANGUAGE.No },
];
const AfterCallCanSeeOptions = [
  { value: APP.LANGUAGE.PostCallSurvey.Options[0].Id, text: APP.LANGUAGE.PostCallSurvey.Options[0].Name },
  { value: APP.LANGUAGE.PostCallSurvey.Options[1].Id, text: APP.LANGUAGE.PostCallSurvey.Options[1].Name },
  { value: APP.LANGUAGE.PostCallSurvey.Options[2].Id, text: APP.LANGUAGE.PostCallSurvey.Options[2].Name },
];

export default function CenterPanelUpdate(props) {
  const dispatch = useDispatch();

  const resetAfterCallForm = () => {
    let resetAfterCallForm = {
      callProviderUrl:
        props.originalAfterCallForm.callProviderUrl == null ? '' : props.originalAfterCallForm.callProviderUrl,
      callerGuestUrl:
        props.originalAfterCallForm.callerGuestUrl == null ? '' : props.originalAfterCallForm.callerGuestUrl,
      postCallUrl: props.originalAfterCallForm.postCallUrl == null ? '' : props.originalAfterCallForm.postCallUrl,
    };
    let updatedAfterCallsForm = objectAssign({}, props.afterCallsForm, resetAfterCallForm);

    dispatch(updateAfterCallsForm(updatedAfterCallsForm));
  };

  const afterCallsFormUpdated = (property, value) => {
    let updatedAfterCallsForm = objectAssign({}, props.afterCallsForm, { [property]: value });
    return updatedAfterCallsForm;
  };

  const changePostCallOption = (event, data) => {
    let resetAfterCallForm = {
      callProviderUrl:
        props.originalAfterCallForm?.callProviderUrl == null ? '' : props.originalAfterCallForm?.callProviderUrl,
      callerGuestUrl:
        props.originalAfterCallForm?.callerGuestUrl == null ? '' : props.originalAfterCallForm?.callerGuestUrl,
      postCallUrl: props.originalAfterCallForm?.postCallUrl == null ? '' : props.originalAfterCallForm?.postCallUrl,
      postCallOption: data.value,
    };
    let updatedAfterCallsForm = objectAssign({}, props.afterCallsForm, resetAfterCallForm);

    dispatch(updateAfterCallsForm(updatedAfterCallsForm));
  };

  const postCallUrlChanged = (value) => {
    dispatch(updateAfterCallsForm(afterCallsFormUpdated('postCallUrl', value)));
  };

  const callProviderUrlChanged = (value) => {
    dispatch(updateAfterCallsForm(afterCallsFormUpdated('callProviderUrl', value)));
  };

  const callerGuestUrlChanged = (value) => {
    dispatch(updateAfterCallsForm(afterCallsFormUpdated('callerGuestUrl', value)));
  };

  let urlForOption2 =
    props.afterCallsForm.postCallOption === 1 ? (
      <div>
        <ValidMe validmefor="httpOrHttpsURL@canBeEmpty" group="afterCallsForm" fieldClasses="mrtl">
          <Txt
            tabIndex="1"
            focusme="true"
            value={props.afterCallsForm.postCallUrl || ''}
            placeholder={APP.LANGUAGE.WaitingAreaAfterCalls.PostCallURLTitleForParticipants}
            noTitle
            onChange={postCallUrlChanged}
          />
        </ValidMe>
        <label className="placeholder-label no-bold color-placeholder div-like">
          {APP.LANGUAGE.WaitingAreaAfterCalls.PostCallURLLeaveBlankForOption2}
        </label>
      </div>
    ) : (
      ''
    );

  let urlForOption3 =
    props.afterCallsForm.postCallOption === 2 ? (
      <div>
        <ValidMe validmefor="httpOrHttpsURL@canBeEmpty" group="afterCallsForm" fieldClasses="mrtl">
          <Txt
            tabIndex="1"
            focusme="true"
            value={props.afterCallsForm.callProviderUrl || ''}
            placeholder={APP.LANGUAGE.WaitingAreaAfterCalls.PostCallURLTitleForServiceProvider}
            noTitle
            onChange={callProviderUrlChanged}
          />
        </ValidMe>
        <ValidMe validmefor="httpOrHttpsURL@canBeEmpty" group="afterCallsForm" fieldClasses="mrtl">
          <Txt
            tabIndex="2"
            value={props.afterCallsForm.callerGuestUrl || ''}
            placeholder={APP.LANGUAGE.WaitingAreaAfterCalls.PostCallURLTitleForParticipantsOption3}
            noTitle
            onChange={callerGuestUrlChanged}
          />
        </ValidMe>
        <label className="placeholder-label no-bold color-placeholder div-like">
          {APP.LANGUAGE.WaitingAreaAfterCalls.PostCallURLLeaveBlankForOption3}
        </label>
      </div>
    ) : (
      ''
    );

  return (
    <span>
      <div className={props.isAdmin == true ? 'ui form minHeightLargerForm' : 'ui form minHeightForm'}>
        <label className="placeholder-label no-bold color-placeholder div-like">
          {APP.LANGUAGE.WaitingAreaAfterCalls.AfterCallCanSeeCaption}
        </label>
        <Dropdown
          className="after-call-dropdown"
          defaultValue={props.afterCallsForm.postCallOption}
          onChange={changePostCallOption}
          fluid
          selection
          options={AfterCallCanSeeOptions}
        />
        {urlForOption2}
        {urlForOption3}
      </div>
    </span>
  );
}
